import React from 'react';

import {
  Button,
  Flex,
  Stack,
  SvgDownload,
} from '@grubhubprod/gh-cookbook-react';

interface IGenerateStateButtonProps {
  onClick: () => void;
}

export function GenerateStateButton({
  onClick,
}: IGenerateStateButtonProps): JSX.Element {
  return (
    <Button
      variant="tertiary"
      buttonSize="medium"
      className="tableActionButtons"
      onClick={onClick}
    >
      <Flex alignItems="center" className="ellipsisOverflow">
        <Stack x="xx-sm">Download pdf</Stack>
        <SvgDownload size="20px" />
      </Flex>
    </Button>
  );
}
